<script>
export default {
  props: ['isActive']
}
</script>

<template>
  <div class="footer-container">
    <div class="footer centralizar" v-bind:class="{ 'footer_left': isActive }">
      &nbsp; Copyright © com &nbsp; <i class="far fa-heart"></i>&nbsp; por Farsoft Systems &nbsp;
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-container {
  width:100%;
  position:fixed;
  bottom:0px;
  background: #2A2F50;
  z-index: 999999;
}

.footer {
  height:30px;
  background:#2a2f50;
  border:0px solid #CCC;
  color: #fff;
  line-height: 30px;
  font-size: 0.8em;
  padding: 0px;
  padding-top: 1px;
}

.footer_left {
  padding-left: 270px;
}

.centralizar {
  margin-left: auto;
  margin-right: auto;
  display:block;
}
</style>
